import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CART_LINK } from '../data/content';
type CTAButtonProps = {
  children: React.ReactNode;
  className?: string;
  size?: 'md' | 'lg';
};
export function CTAButton({
  children,
  className = '',
  size = 'md'
}: CTAButtonProps) {
  const sizing = size === 'lg' ? 'px-8 py-5 text-lg sm:text-xl' : 'px-7 py-4 text-base sm:text-lg';
  return <a href={CART_LINK} className={`group inline-flex w-full items-center justify-center gap-3 rounded-full bg-terracotta font-sans font-bold uppercase tracking-wide text-cream shadow-[0_8px_0_0_#A2401F] transition-[transform,box-shadow,background-color] duration-150 ease-out hover:translate-y-[3px] hover:bg-terracotta-dark hover:shadow-[0_5px_0_0_#A2401F] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-plum active:translate-y-[8px] active:shadow-none sm:w-auto ${sizing} ${className}`} data-id="element-66" data-mp="2tz2znvam9s7t">
      {children}
      <ArrowRightIcon className="h-5 w-5 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-67" data-mp="38mfts8ehp69t" />
    </a>;
}